module.exports = __webpack_public_path__ + "img/0-8.8c258f10.gif";